/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { ClinicalMediaType } from '@/api/apis/case';
import { getFileUrl } from '@/api/utils';

type MediaPreviewThumbnailsProps = {
  media: ClinicalMediaType[];
  currentIndex: number;
  onSelect: (index: number) => void;
  useDirectPath?: boolean;
};

export const MediaPreviewThumbnails = ({
  media,
  currentIndex,
  onSelect,
  useDirectPath = false,
}: MediaPreviewThumbnailsProps) => {
  return (
    <div className="flex shrink-0 flex-row space-x-2 overflow-x-auto">
      {media.map((item, index) => (
        <img
          key={index}
          src={
            useDirectPath
              ? item.file?.preview?.path || item.file?.path
              : getFileUrl(item.file?.preview?.path || item.file?.path)
          }
          alt={item.file.fileName}
          className={`h-[92px] cursor-pointer max-h-[92px] ${
            index === currentIndex ? 'max-w-[92px] border-2 border-white-500' : 'max-w-[60px]'
          }`}
          onClick={() => onSelect(index)}
        />
      ))}
    </div>
  );
};
